// extracted by mini-css-extract-plugin
export default {"root":"style_root__1sJax","loaderContainer":"style_loaderContainer__dhxij","loaderContainer__loaded":"style_loaderContainer__loaded__YhIdV","image":"style_image__6WZtF"};